export default __webpack_public_path__ + "static/media/javascript.00f3e5cf.svg";